import { getApiGalaxyServer, postApiGalaxyServer, putApiGalaxyServer } from 'services';
import { Cohort } from 'TenantModule/api/getCohortsApi';

/**
 * Cohort administration (RDM-2031 resolved Q5): cohorts are registered and edited
 * through Galaxy, never raw SQL. The cluster itself stays IaC-owned — a cohort only
 * REFERENCES its Pulumi-published master secrets by name.
 */
export interface CreateCohortPayload {
  applicationClusterSecret: string;
  integrationClusterSecret?: string;
  capacityLimit?: number;
  region?: string;
}

export interface UpdateCohortPayload {
  capacityLimit?: number;
  applicationClusterSecret?: string;
  /** '' clears the integration secret — workloads fall back to the app cluster. */
  integrationClusterSecret?: string;
  status?: string;
}

/** GET /cohort — every cohort, dedicated ones included (admin view). */
export const getAllCohortsApi = ({ token, config = {} }: BaseApiParams<void>) =>
  getApiGalaxyServer<Cohort[]>(`/cohort`, config, token);

export const createCohortApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<CreateCohortPayload>) =>
  postApiGalaxyServer<CreateCohortPayload, Cohort>(`/cohort`, params, config, token);

export const updateCohortApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<{ id: number; body: UpdateCohortPayload }>) =>
  putApiGalaxyServer<UpdateCohortPayload, Cohort>(
    `/cohort/${params.id}`,
    params.body,
    config,
    token,
  );
